import React from 'react';
import { motion } from 'framer-motion';
import './BlogHero.css';

const BlogHero = () => {
  return (
    <section className="blog-hero">
      <div className="blog-hero-background"></div>
      <div className="blog-hero-content">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h1 className="blog-hero-title">Financial Intelligence Hub</h1>
          <p className="blog-hero-subtitle">
            Expert insights on global finance, trade, and business funding
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default BlogHero;